package pro.jayeshseth.animations.shaders.utils

val BASE_FEATURE_ROUTE =
    "features/shaders/src/main/kotlin/pro/jayeshseth/animations/shaders"